import { render, staticRenderFns } from "./personnel_education.vue?vue&type=template&id=a9ec8686&scoped=true&"
import script from "./personnel_education.vue?vue&type=script&lang=js&"
export * from "./personnel_education.vue?vue&type=script&lang=js&"
import style0 from "./personnel_education.vue?vue&type=style&index=0&id=a9ec8686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ec8686",
  null
  
)

export default component.exports